export const AFFILIATE_PARTNER_ROUTE_PREFIX = "/admin/affiliate-partners";

export const AFFILIATE_PARTNER_ROUTE_PATHS = {
  list: { path: "*", to: AFFILIATE_PARTNER_ROUTE_PREFIX },
};
